export default {
	campaigns: [],
	formats: [],
	templates: [],
	template: null,
	campaign: null,
	format: null,
	images: [],
	currentImageIndex: undefined,
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/store/template-images/state.js